import React from 'react';
import PropTypes from 'prop-types';

function InstagramIcon({ color, width, height }) {
  return (
    <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} fill="none" xmlns="http://www.w3.org/2000/svg">
      {/* eslint-disable-next-line max-len */}
      <path d="M23.2896 0H7.93248C3.70964 0 0.253906 3.45423 0.253906 7.67857V23.0357C0.253906 27.2586 3.70964 30.7143 7.93248 30.7143H23.2896C27.5125 30.7143 30.9682 27.2586 30.9682 23.0357V7.67857C30.9682 3.45423 27.5125 0 23.2896 0ZM15.611 21.7557C12.0766 21.7557 9.21211 18.89 9.21211 15.3571C9.21211 11.8227 12.0766 8.95821 15.611 8.95821C19.1439 8.95821 22.01 11.8227 22.01 15.3571C22.01 18.89 19.1439 21.7557 15.611 21.7557ZM23.9296 8.95821C22.8684 8.95821 22.01 8.09857 22.01 7.03857C22.01 5.97856 22.8684 5.11892 23.9296 5.11892C24.9908 5.11892 25.8493 5.97856 25.8493 7.03857C25.8493 8.09857 24.9908 8.95821 23.9296 8.95821Z" fill={color} />
    </svg>

  );
}

InstagramIcon.propTypes = {
  color: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
};

InstagramIcon.defaultProps = {
  color: '#7ED321',
  width: '31',
  height: '31',
};

export default React.memo(InstagramIcon);
